/**
 * Schemas for the `advisories.*` tRPC procedures.
 *
 * Locale-filtered (one row per locale model). `byCountry` returns
 * advisories matching an ISO 3166-1 alpha-2 country code; advisories
 * with `country_code = NULL` are global and surface in every result.
 */

import { z } from "zod";

export const ADVISORY_SEVERITIES = [
  "info",
  "caution",
  "warning",
  "restricted",
] as const;
export const advisorySeveritySchema = z.enum(ADVISORY_SEVERITIES);
export type AdvisorySeverity = z.infer<typeof advisorySeveritySchema>;

export const advisoryItemSchema = z.object({
  id: z.number().int(),
  outbreakId: z.number().int(),
  countryCode: z.string().length(2).nullable(),
  severity: advisorySeveritySchema,
  headline: z.string(),
  body: z.string(),
  publishedAt: z.date().nullable(),
  expiresAt: z.date().nullable(),
});
export type AdvisoryItem = z.infer<typeof advisoryItemSchema>;

export const advisoriesListInputSchema = z.object({
  /** Restrict to advisories for a specific outbreak. */
  slug: z.string().min(1).max(100).optional(),
  /** Restrict to a country (or NULL/global) match. */
  country: z
    .string()
    .length(2)
    .regex(/^[A-Z]{2}$/)
    .optional(),
});
export type AdvisoriesListInput = z.infer<typeof advisoriesListInputSchema>;

export const advisoriesByCountryInputSchema = z.object({
  country: z
    .string()
    .length(2)
    .regex(/^[A-Z]{2}$/),
});

export const advisoriesListOutputSchema = z.array(advisoryItemSchema);
